import { __rest, __assign } from 'tslib';
import React from 'react';
import { classNames } from '../../utils/classNames/classNames.esm.js';
import '@popperjs/core';

/**
 * Renders its children in _italic_ font.
 *
 * ### Import Guide
 *
 * ```jsx
 * import { Italic } from "@panwds/react-ui";
 * ```
 */
function Italic(_a) {
    var addClassName = _a.addClassName, children = _a.children, dataMetrics = _a.dataMetrics, dataTestId = _a.dataTestId, _b = _a.as, Component = _b === void 0 ? "span" : _b, passThrough = __rest(_a, ["addClassName", "children", "dataMetrics", "dataTestId", "as"]);
    var className = classNames("tw-font-lato tw-italic dark:tw-text-blue-steel-100 tw-tracking-wide", addClassName);
    return (React.createElement(Component, __assign({ "data-metrics": dataMetrics, "data-testid": dataTestId || "italic", className: className }, passThrough), children));
}

export { Italic };
//# sourceMappingURL=Italic.esm.js.map
